import { render, staticRenderFns } from "./approved-students.vue?vue&type=template&id=6b07db05&scoped=true&"
import script from "./approved-students.vue?vue&type=script&lang=js&"
export * from "./approved-students.vue?vue&type=script&lang=js&"
import style0 from "./approved-students.vue?vue&type=style&index=0&id=6b07db05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b07db05",
  null
  
)

component.options.__file = "approved-students.vue"
export default component.exports